/**
 * Client-side environment validation.
 * Throws at startup if any required Firebase variable is missing — better to
 * fail loudly than render a broken app.
 */
import { z } from 'zod';

const envSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  // Square Web Payments SDK — only set when going live. When absent, checkout
  // stays in mock mode (no card field, no charge).
  VITE_SQUARE_ENVIRONMENT: z.enum(['sandbox', 'production']).optional(),
  VITE_SQUARE_APPLICATION_ID: z.string().optional(),
  VITE_SQUARE_LOCATION_ID: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // console.error is allowed by the lint config (no-console allows warn/error).
  console.error('Missing Firebase env vars:', parsed.error.format());
  throw new Error('Missing required Firebase environment variables. See FIREBASE_SETUP.md.');
}

export const env = parsed.data;
